import { ShortcutCategory } from 'dashboard/apps/InquiryTemplateEditor/ShortcutsModal/ShortcutsModal';

export const ITE_BASE_SHORTCUTS: ShortcutCategory[] = [
  {
    label: 'editing',
    shortcuts: [
      { label: 'save', value: ['⌘', 'S'] },
      { label: 'undo', value: ['⌘', 'Z'] },
      { label: 'redo', value: ['⌘', 'ctrl', 'Z'] },
    ],
  },
  {
    label: 'navigation',
    shortcuts: [
      { label: 'zoom in', value: ['⌘', '+'] },
      { label: 'zoom out', value: ['⌘', '-'] },
    ],
  },
];

export const shortcutsMap = {
  'COPY-COMPONENT': {
    label: 'copy selected component',
    value: ['⌘', 'C'],
  },
  'PASTE-COMPONENT': {
    label: 'paste copied component',
    value: ['⌘', 'V'],
  },
  'DELETE-COMPONENT': {
    label: 'delete selected component',
    value: ['⌫'],
  },
};
